// ─── Inject popup styles once ────────────────────────────────────────────────
(function injectUpgradeStyles() {
  if (document.getElementById('upgrade-popup-styles')) return;
  const style = document.createElement('style');
  style.id = 'upgrade-popup-styles';
  style.textContent = `
  `;
  document.head.appendChild(style);
})();

// ─── Inject popup HTML once ───────────────────────────────────────────────────
(function injectUpgradePopup() {
  if (document.getElementById('upgradeOverlay')) return;
  document.body.insertAdjacentHTML('beforeend', `
    <div class="upgrade-overlay" id="upgradeOverlay">
      <div class="upgrade-popup">
        <button class="upgrade-popup__close" id="upgradeClose" aria-label="Close">&#x2715;</button>
        <p class="upgrade-popup__title">Bigger Size, Better Memories</p>
        <p class="upgrade-popup__subtitle">Upgrade For a premium look.</p>
        <div class="upgrade-popup__cards">
          <div class="upgrade-card upgrade-card--selected">
            <span class="upgrade-card__badge">Your Selection</span>
            <img id="upgradeCurrentImage" src="">
            <div class="upgrade-card__title" id="upgradeCurrentTitle"></div>
            <div class="upgrade-card__price"  id="upgradeCurrentPrice"></div>
          </div>
          <div class="upgrade-card upgrade-card--upgrade">
            <span class="upgrade-card__badge">⬆ Upgrade</span>
            <img id="upgradeNewImage" src="">
            <div class="upgrade-card__title" id="upgradeNewTitle"></div>
            <div class="upgrade-card__price"  id="upgradeNewPrice"></div>
          </div>
        </div>
        <div class="upgrade-popup__actions">
          <button class="upgrade-popup__btn upgrade-popup__btn--keep"    id="upgradeKeep">Continue With Current Size</button>
          <button class="upgrade-popup__btn upgrade-popup__btn--upgrade" id="upgradeConfirm">Upgrade to Bigger Size</button>
        </div>
        <p class="botton-line">You can't change the price after placing order</p>
      </div>
    </div>
  `);
})();


// ─── ProductForm custom element ───────────────────────────────────────────────
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // ── Submit handler — checks for upgrade before adding to cart ────────────
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Disable button / show spinner immediately so UX feels responsive
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // ── Build FormData now (used by both paths) ──────────────────────────
        const formData = new FormData(this.form);

        // ── Check for an upgrade candidate ──────────────────────────────────
        const upgrade = this.findUpgradeVariant();

        if (upgrade) {
          // Re-enable button/spinner while popup is open (user hasn't confirmed yet)
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');

          this.showUpgradePopup(evt, formData, upgrade);
        } else {
          // No upgrade — proceed normally
          this.submitToCart(evt, formData);
        }
      }

      // ── Read all variants from the hidden liquid-rendered list ───────────────
      getAllVariants() {
        const inputs = document.querySelectorAll('.main_product_variants input');
        return Array.from(inputs).map(input => ({
          id:        input.getAttribute('variant_id'),
          title:     input.getAttribute('value'),
          price:     input.getAttribute('variant_price'),
          priceRaw:  parseInt(input.getAttribute('variant_price_raw'), 10),
          available: input.getAttribute('variant_available') === 'true',
          image: input.getAttribute('variant_image'),
        }));
      }

      // ── Find the cheapest valid upgrade for the currently selected variant ───
      findUpgradeVariant() {
        const variants   = this.getAllVariants();
        const selectedId = this.variantIdInput.value;
        const selected   = variants.find(v => v.id === selectedId);

        if (!selected) return null;

        // Glass option = everything after the first " / " in the title
        const selectedGlass = selected.title.split(' / ').slice(1).join(' / ').trim();
        const upgrade = variants
          .filter(v =>
            v.id !== selected.id &&
            v.available &&
            v.priceRaw > selected.priceRaw &&
            v.title.split(' / ').slice(1).join(' / ').trim() === selectedGlass
          )
          .sort((a, b) => a.priceRaw - b.priceRaw)[0]; // next size up (lowest price above current)

        // Attach selected info onto the upgrade object for popup use
        if (upgrade) upgrade._selected = selected;

        return upgrade || null;
      }

      // ── Show popup; wire up Keep / Upgrade / Close actions ──────────────────
      showUpgradePopup(evt, formData, upgrade) {   
        const selected = upgrade._selected;
        const overlay  = document.getElementById('upgradeOverlay');
         
        // Populate cards
         console.log(selected,'bhbhbhb', evt)
        document.getElementById('upgradeCurrentTitle').textContent = selected.title;
        document.getElementById('upgradeCurrentPrice').textContent = selected.price;
        document.getElementById("upgradeCurrentImage").src = selected.image;
        

        document.getElementById('upgradeNewTitle').textContent     = upgrade.title;
        document.getElementById('upgradeNewPrice').textContent     = upgrade.price;
        document.getElementById("upgradeNewImage").src = upgrade.image;

        overlay.classList.add('active');

        // ── Re-enable button while popup is visible ────────────────────────
        const restoreButton = () => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        };

        const closePopup = () => {
          overlay.classList.remove('active');
          document.getElementById('upgradeClose').removeEventListener('click', onClose);
          document.getElementById('upgradeKeep').removeEventListener('click', onKeep);
          document.getElementById('upgradeConfirm').removeEventListener('click', onUpgrade);
          overlay.removeEventListener('click', onOverlayClick);
        };

        // Keep original variant → submit as-is
        const onKeep = () => {
          closePopup();
          this.submitToCart(evt, formData);
        };

        // Upgrade → swap variant ID in FormData, then submit
        const onUpgrade = () => {
          // ★ This is the key swap — changes the id that Shopify adds to cart
          formData.set('id', upgrade.id);

          // Also update the hidden input so the form stays in sync
          this.variantIdInput.value = upgrade.id;

          closePopup();
          this.submitToCart(evt, formData);
        };

        // X or backdrop → dismiss, don't submit
        const onClose = () => {
          closePopup();
          restoreButton();
        };

        const onOverlayClick = (e) => {
          if (e.target === overlay) onClose();
        };

        document.getElementById('upgradeClose').addEventListener('click', onClose);
        document.getElementById('upgradeKeep').addEventListener('click', onKeep);
        document.getElementById('upgradeConfirm').addEventListener('click', onUpgrade);
        overlay.addEventListener('click', onOverlayClick);
      }

      // ── The original Shopify fetch-to-cart logic, now a named method ─────────
      submitToCart(evt, formData) {
        // Re-apply disabled state for the actual submission
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      // ── Unchanged helpers ────────────────────────────────────────────────────
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}